/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     * 
     * @type {any}
     * @memberof RoleResponse
     */
    roleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RoleResponse
     */
    organizationGroupIds?: Array<any> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requireIdPorten?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requireEmployeer?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requireUserOrganizationInMinSide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {any}
     * @memberof RoleResponse
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponse
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    helpTextReasonField?: string | null;
}

/**
 * Check if a given object implements the RoleResponse interface.
 */
export function instanceOfRoleResponse(value: object): value is RoleResponse {
    return true;
}

export function RoleResponseFromJSON(json: any): RoleResponse {
    return RoleResponseFromJSONTyped(json, false);
}

export function RoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'roleId': json['roleId'] === undefined ? undefined : json['roleId'] === null ? null : json['roleId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'organizationGroupIds': json['organizationGroupIds'] === undefined ? undefined : json['organizationGroupIds'] === null ? null : json['organizationGroupIds'],
        'requireIdPorten': json['requireIdPorten'] == null ? undefined : json['requireIdPorten'],
        'requireEmployeer': json['requireEmployeer'] == null ? undefined : json['requireEmployeer'],
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] == null ? undefined : json['requireUserOrganizationInMinSide'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function RoleResponseToJSON(json: any): RoleResponse {
    return RoleResponseToJSONTyped(json, false);
}

export function RoleResponseToJSONTyped(value?: RoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleId': value['roleId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationName': value['applicationName'],
        'organizationGroupIds': value['organizationGroupIds'],
        'requireIdPorten': value['requireIdPorten'],
        'requireEmployeer': value['requireEmployeer'],
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'requiresMfa': value['requiresMfa'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

